import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "./context/AuthContext";
import { Toaster } from "./components/ui/sonner";

// Layout
import MainLayout from "./components/layout/MainLayout";

// Pages
import LoginPage from "./pages/LoginPage";
import AdminDashboard from "./pages/AdminDashboard";
import CREDashboard from "./pages/CREDashboard";
import LeadsPage from "./pages/LeadsPage";
import CustomersPage from "./pages/CustomersPage";
import CustomerProfilePage from "./pages/CustomerProfilePage";
import FollowUpsPage from "./pages/FollowUpsPage";
import {
  DueCustomersPage,
  OverdueCustomersPage,
  DelayedCustomersPage,
  NoShowCustomersPage,
} from "./pages/CustomerStatusPages";
import BookingsPage from "./pages/BookingsPage";
import ComplaintsPage from "./pages/ComplaintsPage";
import ReportsPage from "./pages/ReportsPage";
import BranchesPage from "./pages/BranchesPage";
import BranchSettingsPage from "./pages/BranchSettingsPage";
import CREManagementPage from "./pages/CREManagementPage";
import CREPerformancePage from "./pages/CREPerformancePage";
import NoShowCampaignPage from "./pages/NoShowCampaignPage";
import ApiIntegrationsPage from "./pages/ApiIntegrationsPage";
import CallsMenuPage from "./pages/CallsMenuPage";
import LeadsFollowUpPage from "./pages/LeadsFollowUpPage";
import SDRFollowUpPage from "./pages/SDRFollowUpPage";
import DataImportPage from "./pages/DataImportPage";
import CallsDonePage from "./pages/CallsDonePage";
import SearchResultsPage from "./pages/SearchResultsPage";

// Dashboard router based on role
const DashboardRouter = () => {
  const { isAdmin } = useAuth();
  return isAdmin() ? <AdminDashboard /> : <CREDashboard />;
};

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          {/* Public routes */}
          <Route path="/login" element={<LoginPage />} />
          
          {/* Protected routes */}
          <Route path="/" element={<MainLayout />}>
            <Route index element={<Navigate to="/dashboard" replace />} />
            <Route path="dashboard" element={<DashboardRouter />} />
            <Route path="leads" element={<LeadsPage />} />
            <Route path="customers" element={<CustomersPage />} />
            <Route path="customers/:customerId" element={<CustomerProfilePage />} />
            <Route path="follow-ups" element={<FollowUpsPage />} />
            <Route path="leads-follow-ups" element={<LeadsFollowUpPage />} />
            <Route path="sdr-follow-ups" element={<SDRFollowUpPage />} />
            <Route path="calls" element={<CallsMenuPage />} />
            <Route path="due" element={<DueCustomersPage />} />
            <Route path="overdue" element={<OverdueCustomersPage />} />
            <Route path="delayed" element={<DelayedCustomersPage />} />
            <Route path="no-show" element={<NoShowCustomersPage />} />
            <Route path="no-show-campaign" element={<NoShowCampaignPage />} />
            <Route path="bookings" element={<BookingsPage />} />
            <Route path="complaints" element={<ComplaintsPage />} />
            <Route path="calls-done" element={<CallsDonePage />} />
            <Route path="reports" element={<ReportsPage />} />
            <Route path="branches" element={<BranchesPage />} />
            <Route path="branch-settings" element={<BranchSettingsPage />} />
            <Route path="cre-management" element={<CREManagementPage />} />
            <Route path="cre-performance" element={<CREPerformancePage />} />
            <Route path="settings/api-integrations" element={<ApiIntegrationsPage />} />
            <Route path="settings/data-import" element={<DataImportPage />} />
            <Route path="data-import" element={<DataImportPage />} />
            <Route path="search" element={<SearchResultsPage />} />
          </Route>
          
          {/* Catch all */}
          <Route path="*" element={<Navigate to="/dashboard" replace />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-right" richColors />
    </AuthProvider>
  );
}

export default App;
